<template>
  <OverviewCard
    :title="$t('key_dashboard_top_products')"
    :loading="loading"
    :error="error"
    :empty="!data.items.length"
  >
    <div class="d-flex justify-content-between text-uppercase text-xxs text-secondary font-weight-bold mb-2">
      <span>{{ $t("key_dashboard_product") }}</span>
      <span>{{ $t("key_dashboard_units") }}</span>
    </div>
    <div v-for="item in data.items" :key="item.ean" class="product-row">
      <span class="text-xs text-uppercase product-name text-truncate" :title="item.ean">{{ item.name || item.ean }}</span>
      <MeterBar class="flex-grow-1 mx-3" :value="share(item.units)" />
      <span class="text-xs font-weight-bold product-units">{{ format(item.units) }}</span>
    </div>
  </OverviewCard>
</template>

<script>
import MeterBar from "./MeterBar.vue";
import OverviewCard from "./OverviewCard.vue";
import { formatNumber } from "./shared";

export default {
  name: "TopProducts",
  components: { MeterBar, OverviewCard },
  props: {
    data: { type: Object, default: () => ({ items: [] }) },
    loading: { type: Boolean, default: false },
    error: { type: [Object, Error, String], default: null },
  },
  computed: {
    maxUnits() {
      return Math.max(...this.data.items.map((item) => item.units), 0);
    },
  },
  methods: {
    // Bars are relative to the best seller, as in the design.
    share(units) {
      return this.maxUnits ? (units * 100) / this.maxUnits : 0;
    },
    format(value) {
      return formatNumber(value, this.$i18n.locale);
    },
  },
};
</script>

<style scoped>
.product-row {
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
}

.product-name {
  width: 40%;
}

.product-units {
  min-width: 3rem;
  text-align: right;
}
</style>
